import { z } from 'zod';
/**
 * `POST /auth/refresh` carries no body — the refresh token travels only in
 * the `httpOnly` cookie (D-05). `.strict()` so an accidental body field is a
 * loud 400, not a silently ignored no-op.
 */
export const RefreshRequestSchema = z.object({}).strict();
export const RefreshResponseSchema = z.object({
    accessToken: z.string().min(1),
});
//# sourceMappingURL=refresh.js.map